import { Fragment } from 'react'
import { cn } from '../lib/utils'
import './DatasetTableTypes.css'

export interface Table {
  name: string
  columns: {
    name: string
    type: string
  }[]
}

interface Props {
  className?: string
  table: Table | null
}

function DatasetTableTypes({ className = '', table }: Props) {
  return (
    <div
      className={cn(
        'DatasetTableTypes__container grid auto-rows-max grid-cols-2 gap-3 rounded-md px-5 py-4',
        className,
      )}
    >
      {table?.columns?.map(
        (col) =>
          col.name !== 'Unnamed: 0' && ( // Conditional check to exclude "Unnamed: 0" column
            <Fragment key={`col-${col.name}`}>
              <span className="font-bold">{col.name}:</span>
              <span>{col.type}</span>
            </Fragment>
          ),
      )}
    </div>
  )
}

export default DatasetTableTypes
